/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

const getDefaultLang = () => {
  try {
    const saved = window.localStorage.getItem("lang");
    if (saved && saved.toLowerCase().startsWith("ar")) return "ar";
    if (saved && saved.toLowerCase().startsWith("en")) return "en";
  } catch {
    /* ignore */
  }
  return "ar";
};

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: getDefaultLang(),
    supportedLngs: ["ar", "en"],
    fallbackLng: "ar",
    load: "languageOnly",
    debug: false,
    backend: {
      loadPath: window.location.origin + "/locales/{{lng}}/translation.json",
    },
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage"],
      lookupLocalStorage: "lang",
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

export default i18n;
